import { CONFIG } from '../core/config';
import { RiskMatrix } from './admin/risk-matrices/risk-matrix';
import { AssessmentMethod } from './assessment-method';
import { Customer } from './customer';
import { DisplayMethod } from './display-method';
import { Industry } from './industry';
import { IntendedTarget } from './intended-target';
import { ModelStatus } from './model-status';
import { ViewModel } from './view-model';

export class RunnableModelMetadata implements ViewModel {
  readonly friendlyTypeNameSingular: string = 'Runnable Model Metadata';
  readonly apiRoute: string = CONFIG.apiRoutes.runnableModelMetadata;

  modelId: string;
  modelName: string;
  description: string;
  majorVersion: number;
  minorVersion: number;
  status: string;
  equipmentClassId: string;
  equipmentSubUnitId: string;
  equipmentComponentId: string;
  equipmentPartId: string;
  publishedBy: string;
  publishedDate: string;
  creationDate: string;
  createdBy: string;
  lastModifiedDate: string;
  validatedBy: string;
  validatedDate: string;
  sourceModel: string;
  customer: Customer = new Customer();
  intendedTarget: IntendedTarget = new IntendedTarget();
  assessmentMethod: AssessmentMethod = new AssessmentMethod();
  displayMethod: DisplayMethod = new DisplayMethod();
  industry: Industry = new Industry();
  riskMatrix: RiskMatrix = new RiskMatrix();
  riskMatrixFrlEnabled: boolean;
  runOrder: number;
  maxRemainingLifeForFrl: number;
  maxInspectionFrequencyForFrl: number;
  useFrlMostConservativeValue: boolean;
  useFrlFrequencySourceDetection: boolean;

  constructor() {}

  get modelVersion(): string {
    return `${this.majorVersion}.${this.minorVersion}`;
  }

  json(): any {
    return this;
  }

  loadFromJson(data) {
    this.modelId = data.modelId;
    this.modelName = data.modelName;
    this.description = data.description;
    this.majorVersion = data.majorVersion;
    this.minorVersion = data.minorVersion;
    this.status = ModelStatus[data.status];
    this.equipmentClassId = data.equipmentClassId;
    this.equipmentSubUnitId = data.equipmentSubUnitId;
    this.equipmentComponentId = data.equipmentComponentId;
    this.equipmentPartId = data.equipmentPartId;
    this.publishedBy = data.publishedBy;
    this.publishedDate = data.publishedDate;
    this.creationDate = data.creationDate;
    this.createdBy = data.createdBy;
    this.lastModifiedDate = data.lastModifiedDate;
    this.validatedBy = data.validatedBy;
    this.validatedDate = data.validatedDate;
    this.sourceModel = data.sourceModel;
    this.riskMatrixFrlEnabled = data.riskMatrixFrlEnabled;
    this.maxRemainingLifeForFrl = data.maxRemainingLifeForFrl;
    this.maxInspectionFrequencyForFrl = data.maxInspectionFrequencyForFrl;
    this.useFrlMostConservativeValue = data.useFrlMostConservativeValue;
    this.useFrlFrequencySourceDetection = data.useFrlFrequencySourceDetection;
    this.runOrder = data.runOrder;

    if (data.customer) {
      this.customer.customerId = data.customer.customerId;
    }

    if (data.assessmentMethod) {
      this.assessmentMethod.assessmentMethodId =
        data.assessmentMethod.assessmentMethodId;
    }

    if (data.intendedTarget) {
      this.intendedTarget.intendedTargetId =
        data.intendedTarget.intendedTargetId;
    }

    if (data.customer) {
      this.customer.customerId = data.customer.customerId;
    }

    if (data.industry) {
      this.industry.industryId = data.industry.industryId;
    }

    if (data.displayMethod) {
      this.displayMethod.displayMethodId = data.displayMethod.displayMethodId;
    }

    if (data.riskMatrix) {
      this.riskMatrix.loadFromJson(data.riskMatrix);
    }
  }
}
